module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-2.e01d9913.png";